import { FC, useState } from 'react';

import DeleteModal from '../common/DeleteModal';

import { useChatContext } from './ChatContext';

export type ChatThreadDeleteModalProps = {
  threadId: string;
  isActive: boolean;
  open: boolean;
  onClose: () => void;
  onDelete: (threadId: string) => Promise<boolean>;
};

const ChatThreadDeleteModal: FC<ChatThreadDeleteModalProps> = ({
  threadId,
  isActive,
  open,
  onClose,
  onDelete,
}) => {
  const {
    threadsData: { startNewThread },
  } = useChatContext();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);

    await onDelete(threadId);

    // push to a new thread if the active one was just deleted
    if (isActive) {
      startNewThread();
    }

    setLoading(false);

    onClose();
  };

  return (
    <DeleteModal
      open={open}
      title="Delete Chat?"
      content="Are you sure you want to delete this chat?"
      cancelText="Cancel"
      confirmText="Delete"
      onConfirm={handleDelete}
      onCancel={onClose}
      loading={loading}
    />
  );
};

export default ChatThreadDeleteModal;
